<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><a id="a62"></a>Greater Love Hath No Man</h1>
<h2 class="h20"><a id="ncx83"></a><a id="a63"></a>Prologue</h2>
<p class="p2">The envelope was lying on the floor inside the front door of my London town house. It was lavender, and sprinkled lavishly with mimosa, a scent I remembered from my younger years. The word <span class="t6">urgent</span> was scrawled upon it, underscored five times.</p>
<p class="p2">I smiled fondly. Barbara always tended toward the melodramatic. Although why my ex-wife would be writing…</p>
<p class="p2">My heart clenched. Jamie, our son. I could tell the letter had been there for some time. My lover and I had been away for the past two weeks, first to attend a wedding, and then to just spend some time together. Not a honeymoon, for we couldn’t marry, but a pleasurable twelve days with no calls made upon our time.</p>
<p class="p2">Dammit, I should have been home.</p>
<p class="p2">But surely, if anything had happened to Jamie, Barbara would have telephoned?</p>
<p class="p2">I started to slide a thumbnail under the flap but only succeeded in mangling the envelope. With what had she sealed the bloody thing?</p>
<p class="p2">“James? Give it here.” Strong hands…deadly hands—hands that could be surprisingly gentle when exploring my body—took it from me, tapped it on a palm, tore the end and tipped it over, then placed the letter into my hand.</p>
<p class="p2">“Thank you, sweetheart.” Barbara’s lines in the lavender ink she favoured were crossed in a tight scrawl, quite unlike her usual flawless penmanship. Hastily I scanned the page, searching for the disaster that had necessitated this missive.</p>
<p class="p2">“Is everything all right?”</p>
<p class="p2">My son was alive and well. I blew out a relieved breath and smiled at my lover. “Yes. Although Barbara is quite annoyed that I wasn’t available to prevent Jamie from rushing off to Las Vegas to get married.”</p>
<p class="p2">“Beg pardon?”</p>
<p class="p2">“He’s married.”</p>
<p class="p2">“So soon? Well, I’ll be buggered!”</p>
<p class="p2">“That can be arranged.” I grinned at him, almost giddy with relief, and began rereading Barbara’s words, aloud this time, and more slowly. When I finished, I looked up into my lover’s eyes. He ran his fingers through my hair and pressed a kiss to my temple.</p>
<p class="p2">So much time had passed, so much had happened…</p>
<p class="p2">I leaned against him and stared off into space, remembering.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?78ca83cf